module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjEiIGhlaWdodD0iMjEiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJNMzgzLjUgMzQ1YTUuNSA1LjUgMCAxIDAgMC0xMSA1LjUgNS41IDAgMCAwIDAgMTF6bTEyLjUgNC43MmwtMi4yOCAyLjI4LTUuMy01LjNhOC41OSA4LjU5IDAgMSAxIDIuMjgtMi4yOHoiLz48L2RlZnM+PHVzZSBmaWxsPSIjZmZmIiB4bGluazpocmVmPSIjYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM3NSAtMzMxKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search.svg
// module id = 868
// module chunks = 0